import { HeaderText } from "../atoms/HeaderText";
import EmptyStateBox from "../atoms/EmptyStateBox";

export default function ArchivedSection() {
  return (
    <div className="p-6">
      <HeaderText title="Archived" subtitle="Requests older than 60 days" />
      <EmptyStateBox message="You have no archives so far!" />
         
    </div>
  );
}
